<template>
    <div>
        <div
            class="modal fade"
            tabindex="-1"
            role="dialog"
            ref="modal"
        >
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content image-modal-content">

                    <div class="modal-header image-modal-header">
                        <h5 class="modal-title">
                            <i class="fa fa-image mr-2"></i> Rasm yuklash
                        </h5>
                        <button type="button" class="close" @click="close">
                            <span>&times;</span>
                        </button>
                    </div>

                    <div class="modal-body p-4">

                        <!-- Preview -->
                        <div class="preview-wrapper mb-4" v-if="image">
                            <div class="preview-label">Joriy rasm</div>
                            <div class="preview-box">
                                <img :src="image" class="preview-img" />
                            </div>
                        </div>

                        <!-- Drop zone -->
                        <div
                            class="drop-zone"
                            :class="{ 'drop-zone--active': isDragging, 'drop-zone--has-file': !!file }"
                            @dragover.prevent="isDragging = true"
                            @dragleave.prevent="isDragging = false"
                            @drop.prevent="handleDrop"
                            @click="$refs.fileInput.click()"
                        >
                            <input
                                type="file"
                                ref="fileInput"
                                accept="image/*"
                                style="display:none"
                                @change="handleFileUpload"
                            />
                            <div class="drop-zone__icon">
                                <i class="fa fa-cloud-upload"></i>
                            </div>
                            <div class="drop-zone__text" v-if="!file">
                                <span class="drop-zone__main">Rasm tanlash uchun bosing</span>
                                <span class="drop-zone__sub">yoki shu yerga tashlang</span>
                            </div>
                            <div class="drop-zone__text" v-else>
                                <span class="drop-zone__main text-success">
                                    <i class="fa fa-check-circle mr-1"></i> {{ file.name }}
                                </span>
                                <span class="drop-zone__sub">O'zgartirish uchun bosing</span>
                            </div>
                        </div>

                    </div>

                    <div class="modal-footer image-modal-footer">
                        <button class="btn btn-light btn-sm px-4" @click="close" :disabled="loading">
                            Bekor qilish
                        </button>
                        <button class="btn btn-primary btn-sm px-4" @click="save" :disabled="loading || !file">
                            <span v-if="loading">
                                <i class="fa fa-spinner fa-spin mr-1"></i> Saqlanmoqda...
                            </span>
                            <span v-else>
                                <i class="fa fa-save mr-1"></i> Saqlash
                            </span>
                        </button>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        initialImage: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            image: this.initialImage,
            file: null,
            isDragging: false,
            loading: false
        };
    },
    methods: {
        open() {
            this.image = this.initialImage;
            this.file = null;
            this.loading = false;
            if (this.$refs.fileInput) {
                this.$refs.fileInput.value = '';
            }
            $(this.$refs.modal).modal('show');
        },
        close() {
            $(this.$refs.modal).modal('hide');
            this.$emit('close');
        },
        handleFileUpload(e) {
            const file = e.target.files[0];
            if (file) {
                this.file = file;
                this.image = URL.createObjectURL(file);
            }
        },
        handleDrop(e) {
            this.isDragging = false;
            const file = e.dataTransfer.files[0];
            if (file && file.type.startsWith('image/')) {
                this.file = file;
                this.image = URL.createObjectURL(file);
            }
        },
        save() {
            this.loading = true;
            this.$emit('save', this.file);
            this.close();
            this.loading = false;
        }
    },
    watch: {
        initialImage: {
            handler(newVal) {
                this.image = newVal;
            },
            immediate: true
        }
    }
};
</script>

<style scoped>
.image-modal-content {
    border: none;
    border-radius: 12px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
    overflow: hidden;
}

.image-modal-header {
    background: linear-gradient(135deg, #4f8ef7 0%, #3a6fd8 100%);
    color: #fff;
    border-bottom: none;
    padding: 16px 20px;
}

.image-modal-header .modal-title {
    font-size: 15px;
    font-weight: 600;
}

.image-modal-header .close {
    color: #fff;
    opacity: 0.8;
    text-shadow: none;
}

.image-modal-header .close:hover {
    opacity: 1;
}

.preview-label {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    color: #888;
    letter-spacing: 0.5px;
    margin-bottom: 8px;
}

.preview-box {
    border: 2px solid #e8edf5;
    border-radius: 10px;
    padding: 8px;
    background: #f8fafd;
    text-align: center;
}

.preview-img {
    max-height: 180px;
    max-width: 100%;
    border-radius: 6px;
    object-fit: contain;
    box-shadow: 0 4px 12px rgba(0,0,0,0.08);
}

.drop-zone {
    border: 2px dashed #c5d3e8;
    border-radius: 10px;
    padding: 32px 20px;
    text-align: center;
    cursor: pointer;
    transition: all 0.2s ease;
    background: #f8fafd;
}

.drop-zone:hover {
    border-color: #4f8ef7;
    background: #eef4ff;
}

.drop-zone--active {
    border-color: #4f8ef7;
    background: #e6efff;
    transform: scale(1.01);
}

.drop-zone--has-file {
    border-color: #28a745;
    background: #f0fff4;
}

.drop-zone__icon {
    font-size: 32px;
    color: #b0bec5;
    margin-bottom: 10px;
}

.drop-zone--active .drop-zone__icon,
.drop-zone:hover .drop-zone__icon {
    color: #4f8ef7;
}

.drop-zone--has-file .drop-zone__icon {
    color: #28a745;
}

.drop-zone__text {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.drop-zone__main {
    font-size: 14px;
    font-weight: 500;
    color: #444;
}

.drop-zone__sub {
    font-size: 12px;
    color: #aaa;
}

.image-modal-footer {
    border-top: 1px solid #f0f0f0;
    padding: 12px 20px;
    gap: 8px;
}
</style>
